import { createExcelAndDownload } from '../../../utils/reportExcelExport';

export function Report(visitors) {
    const customHeadings = [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "gender", label: "Phone Number" },
        { key: "cnic", label: "Cnic" },
        { key: "address", label: "Address" },
        { key: "created_at", label: "Visit Date", isDate: true },
    ];
    createExcelAndDownload("Visitor Report", visitors, customHeadings);
}
